import React, { FunctionComponent } from "react";
import kebabCase from "lodash.kebabcase";
import { ButtonColour, ButtonSize } from "@trussle/external-components";
import { IContentfulBackgroundColour } from "../../../types/IContentfulBackgroundColour";
import { ICTA } from "../../../types/ICTA";
import { addTracking, CallToActions } from "../../CallToActions";
import { Heading } from "../../Heading";
import { ImageWithTitleAndText, IProps as IImageWithTitleProps } from "../../ImageWithTitleAndText";
import "./style.scss";
import { PanelWrapper } from "../../PanelWrapper";

export interface IFeaturesWithCTAsProps {
  title?: string;
  headingType?: string;
  imagesWithTitleAndText: IImageWithTitleProps[];
  ctas?: ICTA[];
  backgroundColour?: IContentfulBackgroundColour;
  headerAnchor?: string;
}

export const FeaturesWithCTAs: FunctionComponent<IFeaturesWithCTAsProps> = ({
  imagesWithTitleAndText,
  ctas,
  backgroundColour = "white",
  title,
  headingType,
  headerAnchor,
}) => (
  <PanelWrapper backgroundColour={backgroundColour}>
    { /* eslint-disable-next-line jsx-a11y/no-redundant-roles */ }
    <section
      role="region"
      aria-label="Call for user action"
      className={`features-with-ctas ${backgroundColour}`}
      data-testid="features-with-ctas"
      id={headerAnchor}
    >
      {title && (
      <Heading
        {...(title && {
          id: kebabCase(title.toLowerCase()),
        })}
        className={backgroundColour === "navy" ? "title dark" : "title"}
        type={headingType}
      >
        {title}
      </Heading>
      )}
      <div className="features">
        {imagesWithTitleAndText
        && imagesWithTitleAndText.map((props, index) => (
          <ImageWithTitleAndText
            key={index}
            {...props}
            theme={backgroundColour === "navy" ? "dark" : "light"}
          />
        ))}
      </div>
      {ctas && (
      <CallToActions
        containerClassName="ctas"
        alignment="center"
        size={ButtonSize.Large}
        secondaryCtaColour={backgroundColour === "grey" ? ButtonColour.TertiaryLight : ButtonColour.Secondary}
        ctas={addTracking("Features with ctas", ...ctas)}
      />
      )}
    </section>
  </PanelWrapper>
);
